export default __webpack_public_path__ + "static/media/fortnite-logo.cebdb2f8.png";